import { ShowButton } from "react-admin";

function CustomShowButton() {
  return <ShowButton variant="fieldwire-primary" />;
}

export default CustomShowButton;
